import { LAYOUTS } from "@voltmoney/types";
import { ROUTE } from "../../../../routes";
import { WIDGET } from "@voltmoney/schema";
import { api } from "../../../../configs/api";
import { getAppHeader } from "../../../../configs/config";
import { getApplicationId } from "../mfCentralEvaluateFunds/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const template = async (height, availableCreditAmount, isFromEnhanceLimit) => {
    return {
        layout: {
            id: ROUTE.MFC_FETCH_LANDING,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "mfCentralLandingPage", type: WIDGET.MFC_FETCH_LANDING_PAGE }
            ],
        },
        datastore: {
            mfCentralLandingPage: {
                windowHeight: height,
                availableCreditAmount: availableCreditAmount,
                isFromEnhanceLimit: isFromEnhanceLimit
            }
        },
    };
};
export const mfCentralFetchLandingMf = {
    onLoad: async ({ getHeight, network, navigateWithClear, instrumentTrack }) => {
        await instrumentTrack("MFC_CONGRATULATIONS_SCREEN_VIEWED");
        const applicationId = await getApplicationId();
        const pledgeLimitResponse = await network
            .get(`${api.pledgeLimit}${applicationId}`, { headers: await getAppHeader() });
        let availableCreditAmount;
        if (pledgeLimitResponse?.status === 200) {
            availableCreditAmount = pledgeLimitResponse?.data?.stepResponseObject?.availableCreditAmount;
        }
        setTimeout(async () => {
            await navigateWithClear(ROUTE.MFC_FETCH_ANCHOR);
        }, 3000);
        const isFromEnhanceLimit = await AsyncStorage.getItem("application_id") !== null;
        return Promise.resolve(template(getHeight(), availableCreditAmount, isFromEnhanceLimit));
    },
    actions: {},
    clearPrevious: true,
};
